export default "__VITE_ASSET__CIaVZv_E__"